import { useEffect, useRef } from 'react'
import { consumer } from './cable'
import type { Subscription } from '@rails/actioncable'

export function useNotifications(onNotification: (data: Record<string, unknown>) => void) {
  const callbackRef = useRef(onNotification)
  callbackRef.current = onNotification

  useEffect(() => {
    const subscription: Subscription = consumer.subscriptions.create('NotificationsChannel', {
      received(data: Record<string, unknown>) {
        callbackRef.current(data)
      },
    })

    return () => {
      subscription.unsubscribe()
    }
  }, [])
}
